const BASE_URL = 'worker-score';

export const WORKER_SCORE_LIST_VIEW_STORAGE_KEY = 'workerScoreNotesListView';

export const PATHS = {
  BASE_URL,
  RANKING: `${BASE_URL}/ranking`,
  NOTES: `${BASE_URL}/notes`,
};

export const WORKER_SCORE_VIEWPORT_OFFSET = 140;
